<template>
  <div>
     <button class="rm-button" v-on:click="btnClick()">{{label}}</button>
  </div>
</template>
<script>
export default {
    name: 'rm-button',
    data: function () {
        return {
            count: 0
        }
    },
    props: {
        label: String,
        action: Function
    },
    created () { },
    mounted () { },
    methods: {
        btnClick: function (item) {
            if (this.action) {
                this.action()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/rm-button.vue